import { BrowserTracker, BuildType, Settings } from "@scopely/web-sdk-analytics";
import { OktaProviderConfig } from "@scopely/web-sdk-scopelyid";
import { Config as ScopelyIdConfig } from "@scopely/web-sdk-scopelyid/dist/src/settings";
import {bootstrapScopelyIdentity} from '@scopely/web-sdk-scopely-account';
import {
  APP_REDIRECT_URL,
  APP_REDIRECT_URL_LOGOUT,
  SCOPELY_ID_AUTH_URL,
  SCOPELY_ID_CLIENT_ID,
  SCOPELY_ID_PROVIDER_URL,
  TITAN_API_KEY,
} from "~/constants/providers";
import {isDebugLogEnabled} from "~/utils/debug.ts";

const isProduction = ["staging", "production"].includes(import.meta.env.VITE_APP_ENVIRONMENT);

let buildType: BuildType = BuildType.Debug;
if (isProduction) {
  buildType = BuildType.Production;
}
const settings = new Settings(TITAN_API_KEY, buildType);
// settings.withDebug(true);
//settings.withPreview(true);
settings.withFlushIntervalMillis(5000);
const tracker = new BrowserTracker(settings);

const registerStartTime = performance.now();
const registeredTracker = tracker.register().then(() => {
  const registerFinishTime = performance.now();
  if (isDebugLogEnabled()) {
    console.log({registerStartTime, registerFinishTime, registerTime: registerFinishTime - registerStartTime})
  }
});

// Titan Analytics
interface TitanEvent {
  name: string;
  parameters: Record<string, unknown>;
}

const Titan = {
  SendEvent: (event: TitanEvent): void => {
    if (event.name && event.parameters) {
      tracker.track(event.name, event.parameters);
      // @ts-expect-error
      window?.DD_RUM?.addAction("titan-events-count", {
        event: event.name,
        params: event.parameters,
      });
    } //else {
    // console.error(`Trying to send malformed event: ${JSON.stringify(event)}`);
    //}
  },
};

const providerConfig = new OktaProviderConfig(
  SCOPELY_ID_PROVIDER_URL,
  SCOPELY_ID_CLIENT_ID,
  APP_REDIRECT_URL,
  APP_REDIRECT_URL_LOGOUT,
);
const scopelyIdCfg = new ScopelyIdConfig(providerConfig, SCOPELY_ID_AUTH_URL);

// Auto-configuration with ScopelyId compatibility
const scopelyId = registeredTracker.then(() => {
    return bootstrapScopelyIdentity({
      config: scopelyIdCfg,
      tracker,
    })
  }).catch((error)=> {
  console.error('Failed to initialize identity service:', error);
})

export { scopelyId, tracker, Titan };
